import {
  faGear,
  faMessage,
  faVideo,
  faVideoSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SettingsIcon } from "../../SvgIcons/SettingIcon";

interface ButtonProps {
  isOn: boolean;
  onClick: () => void;
}

// Camera Button
const SettingsButton: React.FC<ButtonProps> = ({ isOn, onClick }) => (
  <button
    onClick={onClick}
    className={`w-14 h-14 text-white text-xl rounded-2xl transition flex justify-center align-middle items-center ${
      isOn ? "bg-[#555] hover:bg-[#666]" : "bg-[#7E57C2] hover:bg-[#6846a1]"
    }`}
  >
    {isOn ? <SettingsIcon size={20} /> : <SettingsIcon size={20} />}
  </button>
);

export default SettingsButton;
